module.exports = __webpack_public_path__ + "img/Google_Sheets_2020_Logo.0fb842da.svg";